import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

function LeftArrow({ width = 24, height = 24, color = 'white', className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.53 5.47a.75.75 0 010 1.06l-4.72 4.72H19a.75.75 0 010 1.5H6.81l4.72 4.72a.75.75 0 11-1.06 1.06l-6-6a.75.75 0 010-1.06l6-6a.75.75 0 011.06 0z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 12a.75.75 0 01.75-.75h8a.75.75 0 010 1.5h-8a.75.75 0 01-.75-.75z"
        fill={color}
      />
    </svg>
  );
}

export default LeftArrow;
